import YouTube, { Options } from 'react-youtube';
import VisibilitySensor from 'react-visibility-sensor';
import { getYoutubeURL, getYoutubeVideoId } from 'utils/stream';
import { useRef } from 'react';
import { YoutubeWrapper } from './styled';

interface YoutubePlayerProps {
  content: any;
  autoplay?: boolean;
  dataCyName?: string;
}

function YoutubePlayer({
  content,
  autoplay = true,
  dataCyName = '',
}: YoutubePlayerProps) {
  const playerRef = useRef();
  const youtubeUrl = getYoutubeURL(content);
  const youtubeId = getYoutubeVideoId(youtubeUrl);

  const youtubeOptions: Options = {
    width: '100%',
    playerVars: {
      autoplay: 0,
      mute: 1,
    },
  };

  const handleChangeVisibility = (isVisible) => {
    if (autoplay) {
      if (isVisible && playerRef) {
        // @ts-ignore
        playerRef?.current?.internalPlayer?.playVideo();
      } else {
        // @ts-ignore
        playerRef?.current?.internalPlayer?.pauseVideo();
      }
    }
  };

  if (youtubeId) {
    return (
      <VisibilitySensor
        onChange={handleChangeVisibility}
        minTopValue={100}
        scrollCheck
        scrollDelay={1000}
        intervalDelay={2000}
      >
        <YoutubeWrapper data-cy={dataCyName}>
          <YouTube videoId={youtubeId} opts={youtubeOptions} ref={playerRef} />
        </YoutubeWrapper>
      </VisibilitySensor>
    );
  }

  return null;
}

export default YoutubePlayer;
